import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-become-creator-values-title gfu-hd gfu-hd--h2 _tac" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("h3", _hoisted_1, [
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(_ctx.typerText), 1 /* TEXT */),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-animation-blink _tc--accent _fw-n" }, "|", -1 /* CACHED */))
    ])
  ]))
}